import { api, getToken, setToken } from "./api";
import { renderDashboard } from "./pages/dashboard";
import { renderUsers } from "./pages/users";
import { renderChats } from "./pages/chats";
import { renderUserbot } from "./pages/userbot";
import { renderPayments } from "./pages/payments";
import { renderLogs } from "./pages/logs";
import { renderTiers } from "./pages/tiers";
import { renderPartners } from "./pages/partners";

const app = document.getElementById("app")!;
const who = document.getElementById("who")!;

async function ensureAuth(): Promise<boolean> {
  if (!getToken()) {
    await loginFlow();
    return !!getToken();
  }
  try {
    const s = await api.summary();
    who.textContent = `${s.total_users} users · ${s.today_dau} DAU today`;
    return true;
  } catch (e: any) {
    if (e.status === 401 || e.status === 403) {
      setToken(null);
      await loginFlow();
      return !!getToken();
    }
    return false;
  }
}

async function loginFlow(): Promise<void> {
  app.innerHTML = `<div class="card empty">Подключение Telegram…</div>`;
  const init = await api.authInit();
  app.innerHTML = `
    <div class="card" style="max-width:520px;margin:40px auto">
      <h1>Вход в админку</h1>
      <p>Авторизуйся через Telegram — только аккаунты из <code>ADMIN_IDS</code> получат доступ.</p>
      <p><a href="${init.login_url}" target="_blank" rel="noopener"><button>Открыть Telegram</button></a></p>
      <p id="status" style="color:#7b8499">Ожидание подтверждения…</p>
    </div>
  `;
  const status = document.getElementById("status")!;
  const start = Date.now();
  while (Date.now() - start < 10 * 60_000) {
    await new Promise(r => setTimeout(r, 2000));
    try {
      const r = await api.authCheck(init.state);
      if (r.status === "ok" && r.session_token) {
        if (!r.is_admin) {
          status.textContent = "❌ Это не админ-аккаунт.";
          return;
        }
        setToken(r.session_token);
        location.reload();
        return;
      }
    } catch {}
  }
  status.textContent = "Время вышло.";
}

async function route(): Promise<void> {
  if (!await ensureAuth()) return;
  const hash = location.hash.slice(2) || "dashboard";
  document.querySelectorAll(".side nav a").forEach(a => {
    a.classList.toggle("active", a.getAttribute("href") === `#/${hash}`);
  });
  app.innerHTML = "";
  switch (hash) {
    case "dashboard": return renderDashboard(app);
    case "users": return renderUsers(app);
    case "chats": return renderChats(app);
    case "userbot": return renderUserbot(app);
    case "payments": return renderPayments(app);
    case "tiers": return renderTiers(app);
    case "partners": return renderPartners(app);
    case "logs": return renderLogs(app);
    default:
      app.innerHTML = `<div class="empty">404</div>`;
  }
}

window.addEventListener("hashchange", route);
route();
